import { AvailabilityError } from './SeeRefundabilityParts/AvailabilityError';
import { CancellationFeeError } from './SeeRefundabilityParts/CancellationFeeError';
import { CancellationFeeCheck } from './SeeRefundabilityParts/CancellationFeeCheck';
import RefundabilityDisplay from './SeeRefundabilityParts/RefundabilityDisplay';

const getRefundabilityState = ({
  cancelationFee,
  validationError,
  hotelCancelationFeeError,
}) => {
  if (validationError) {
    return 'availabilityError';
  }
  if (hotelCancelationFeeError) {
    return 'cancellationError';
  }
  if (typeof cancelationFee?.CanBeCanceled === 'boolean') {
    return 'refundableOrNot';
  }
  return 'fetchCancellationFee';
};

const SeeRefundability = props => {
  const {
    index,
    check_in,
    cancelationFee,
    taxAlign = 'center',
    textDirection = 'column',
    textPadding = 0,
    isaBuying = false,
    onCheckCancellationFee = () => {},
    hotelCancelationFeeError,
    validationError,
    validateHotelBeforeContinue = () => {},
    checkingCancellation,
  } = props;

  const isInline = textDirection === 'row';
  const containerStyle = { alignItems: taxAlign, paddingLeft: textPadding };
  const layout = isInline ? 'inline' : 'stacked';

  const refundabilityState = getRefundabilityState({
    validationError,
    cancelationFee,
    hotelCancelationFeeError,
  });

  const views = {
    availabilityError: (
      <AvailabilityError onRetry={validateHotelBeforeContinue} />
    ),
    cancellationError: <CancellationFeeError />,
    refundableOrNot: (
      <RefundabilityDisplay
        index={index}
        check_in={check_in}
        cancelationFee={cancelationFee}
        isaBuying={isaBuying}
        containerStyle={containerStyle}
        layout={layout}
      />
    ),
    fetchCancellationFee: (
      <CancellationFeeCheck
        index={index}
        onCheckCancellationFee={onCheckCancellationFee}
        loading={checkingCancellation}
      />
    ),
  };

  return views[refundabilityState] ?? null;
};

export default SeeRefundability;
